import {CartItemBuilder} from 'components/common/CartItemBuilder/CartItemBuilder'
import {DEFAULT_CART_ITEM} from 'components/common/CartItemBuilder/providers/InputProvider/consts'
import {useOrderCurrencySwitcher} from 'hooks/useOrderCurrencySwitcher'
import {EnvironmentProvider, useEnvironment} from 'providers/EnvironmentProvider'
import {useRoot, useRootElement} from 'providers/RootProvider'
import {useCallback} from 'react'
import {v4 as uuid} from 'uuid'

export const View = () => {
  useOrderCurrencySwitcher()
  const productId = EnvironmentProvider.useProductId()
  const optionId = EnvironmentProvider.useOptionalOptionId() || ''
  const envStepOrder = useEnvironment().stepOrder
  const root = useRoot()
  const rootElement = useRootElement()

  const onClose = useCallback(() => {
    root.unmount()
    rootElement.remove()
  }, [root, rootElement])

  const stepOrder = envStepOrder ?? (optionId ? 'optionFirst' : 'guestsFirst')

  return (
    <CartItemBuilder
      initialState={{...DEFAULT_CART_ITEM, productId, optionId, id: uuid()}}
      onClose={onClose}
      action="creatingFirst"
      stepOrder={stepOrder}
    />
  )
}
